<template>
  <div id="profile-image">
    <img
      ref="image"
      v-if="user.profileImgUrl"
      :src="userImage"
      :width="size"
      :height="size"
    />
    <avatar v-else :text="user.fullName" :fontSize="fontSize" :size="size" />
  </div>
</template>

<script>
export default {
  name: "ProfileImage",
  props: {
    user: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: "80px"
    },
    fontSize: {
      type: String,
      required: false,
      default: "30px"
    }
  },
  components: {},
  data: () => ({}),
  mounted() {
    if (this.$refs.image) {
      this.$refs.image.style.width = this.size;
      this.$refs.image.style.height = this.size;
    }
  },
  computed: {
    userImage() {
      // return `${process.env.VUE_APP_API_IMG_URL}/${this.user.profileImgUrl}`;
      return "";
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#profile-image {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    object-fit: cover;
    border-radius: 50%;
    border: 1px solid $color-primary;
    padding: 3px;
  }
}
</style>
